// extracted by css-extract-rspack-plugin
export default {"container":"NBVoz","key":"tqmCa","value":"S2PVc","rating_wrapper":"xypXh","ratingWrapper":"xypXh"};